/**
 * Product page presentation logic: gallery thumbnail swap. The car-fit selector and
 * commerce logic (variant/price, cart) live in product-buy-options.js, shared with the
 * quick-buy popup.
 */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    // --- Gallery ---
    var slides = document.querySelectorAll('[data-gallery-slide]');
    var thumbs = document.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        var index = Number(thumb.getAttribute('data-index'));
        slides.forEach(function (slide, i) {
          slide.hidden = i !== index;
          var video = slide.querySelector('video');
          if (video && i !== index) video.pause();
        });
      });
    });
  });
})();
